import { render } from "./hotel_only_item.vue?vue&type=template&id=e684d676"
import script from "./hotel_only_item.vue?vue&type=script&lang=js"
export * from "./hotel_only_item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__